module.exports = __webpack_public_path__ + "static/img/carts.7bae519f.png";